import { setFontVariant } from "@similarweb/styles";
import styled from "styled-components";
import { SWReactIcons } from "@similarweb/icons";
import { IconButton } from "@similarweb/ui-components";
import type { IBannerTheme } from "../StyledTrialBanner";

export const StyledIconButton = styled(IconButton)<{ theme: IBannerTheme }>`
    line-height: normal;
    ${SWReactIcons} {
        path {
            fill: ${({ theme }) => theme.ctaButtonColor}!important;
        }
    }
`;

export const ButtonText = styled.span<{ theme: boolean }>`
    ${({ theme }) => setFontVariant("button", theme.ctaButtonColor)};
`;
